import React from 'react'
import { NavLink } from 'react-router-dom'
import PhenobleLogo  from '../assets/images/Phenoble2.png'
import classes from './FooterNavigation.module.css'
import { FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa'


const FooterNavigation = () => {

    let year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <div className="container py-5">
        <div className="row align-items-start gy-4">
          <div className="col-sm-12 col-md-3 col-lg-3 text-center text-md-start">
            <NavLink to='/'>
              <img src={PhenobleLogo} alt='header-logo' className={classes.footerlogo} />
            </NavLink>
            <p className={classes.aboutText}>Empowering organizations, empowering people.<br />Phenoble Software Pvt Ltd</p>
          </div>
          <div className="col-sm-12 col-md-3 col-lg-2">
            <h5 className={classes.sectionTitle}>Quick Links</h5>
            <ul className={classes.linkList}>
              <li><NavLink to='/' className={classes.footerLink}>Home</NavLink></li>
              <li><NavLink to='/services' className={classes.footerLink}>Services</NavLink></li>
              <li><NavLink to='/about' className={classes.footerLink}>About</NavLink></li>
              <li><NavLink to='/career' className={classes.footerLink}>Career</NavLink></li>
              <li><NavLink to='/blog' className={classes.footerLink}>Blog</NavLink></li>
              <li><NavLink to='/contact' className={classes.footerLink}>Contact</NavLink></li>
            </ul>
          </div>
          <div className="col-sm-12 col-md-3 col-lg-2">
            <h5 className={classes.sectionTitle}>Follow Us</h5>
            <div className={classes.socialIcons}>
              <a href='https://twitter.com/' className={classes.socialIcon} target='_blank' rel='noopener noreferrer'><FaTwitter /></a>
              <a href='https://www.linkedin.com/company/phenoble-software/' className={classes.socialIcon} target='_blank' rel='noopener noreferrer'><FaLinkedin /></a>
              <a href='https://www.instagram.com/' className={classes.socialIcon} target='_blank' rel='noopener noreferrer'><FaInstagram /></a>
            </div>
          </div>
          <div className="col-sm-12 col-md-3 col-lg-3">
            <h5 className={classes.sectionTitle}>Connect with us</h5>
            <ul className={classes.contactList}>
              <li>sales@phenoble.com</li>
              <li>hr@phenoble.com</li>
              <li>+91 7850952954</li>
            </ul>
          </div>
        </div>
        <hr className={classes.divider} />
        <div className="text-center pt-2">
          <p className={classes.copyright}>&#169; {year} Phenoble Software Private Limited</p>
        </div>
      </div>
    </footer>
  )
}

export default FooterNavigation